import { useState } from 'react'

export interface ChildProps {
  readonly checked: boolean
  readonly isUpdating: boolean
  readonly setIsUpdating: (isUpdating: boolean) => void
}

interface Props {
  readonly checked: boolean
  readonly children: (props: ChildProps) => any
}

/**
 * @description Wrap a checkbox, toggle, or any other boolean-logic UI view in this component
 * if you want the UI view to update immediately after user interaction, even if you are still
 * waiting on an async request or other side effect.
 */
export function OptimisticToggleManager({ checked, children }: Props) {
  const [isUpdating, setIsUpdating] = useState(false)
  return children({
    checked: isUpdating ? !checked : checked,
    isUpdating,
    setIsUpdating
  })
}
